import { useEffect } from "react";

const calculateRootMargin = () => {
    const height = window.innerHeight;
    if (height < 880) return "-400px 0px -20% 0px";
    return "-400px 0px -50% 0px";
};

const useSectionObserver = (
    setCurrentSection: React.Dispatch<React.SetStateAction<string>>,
    setClickedId: React.Dispatch<React.SetStateAction<string>>,
) => {
    useEffect(() => {
        const container = document.getElementById("form-product");
        if (!container) return;

        const observer = new IntersectionObserver(
            entries => {
                const visibleSection = entries.find(entry => entry.isIntersecting);
                if (visibleSection) {
                    setCurrentSection(visibleSection.target.id);
                    setClickedId("");
                }
            },
            {
                root: null,
                rootMargin: calculateRootMargin(),
                threshold: 0.06,
            },
        );

        const sections = container.querySelectorAll("div[id*='section']");
        sections.forEach(section => observer.observe(section));

        return () => {
            sections.forEach(section => observer.unobserve(section));
        };
    }, []);
};

export { useSectionObserver };
